"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPositionChange = void 0;
var helper_1 = require("./helper");
var CHECK_POSITION_INTERVAL = 100;
function checkPositionChange(dom, onChange) {
    if (!dom) {
        return helper_1.emptyFn;
    }
    var prevPosition = dom.getBoundingClientRect();
    var checkTimer = setInterval(function () {
        var position = dom.getBoundingClientRect();
        if (Math.abs(prevPosition.left - position.left) > 1
            || Math.abs(prevPosition.top - position.top) > 1) {
            onChange();
        }
        prevPosition = position;
    }, CHECK_POSITION_INTERVAL);
    return function () { return clearInterval(checkTimer); };
}
exports.checkPositionChange = checkPositionChange;
